import styled from 'styled-components'

import {
  backgroundTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
} from '../types'
import { background, boxModel, css, display } from '../util'

/**
 * @namespace Section
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Section = styled.section`
  ${background};
  ${boxModel};
  ${css};
  ${display};
`

/**
 * @name defaultProps
 * @memberof Section
 * @desc Primitive's default properties
 */
Section.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Section
 * @desc Primitive's prop type definitions
 */
Section.propTypes = {
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
}

/** @component */
export default Section
